import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { LOGO_PATHS } from '@/lib/constants/logo-paths';

export type LogoSize = 'sm' | 'md' | 'lg';

interface LogoProps {
  className?: string;
  showText?: boolean;
  size?: LogoSize;
  href?: string;
}

const sizeClasses = {
  sm: 'h-12 w-12', // 48px - uses header height (h-14 = 56px, logo fills most of it)
  md: 'h-14 w-14', // 56px - default size
  lg: 'h-16 w-16', // 64px - larger contexts
};

const textSizeClasses = {
  sm: 'text-lg', // Larger text for header
  md: 'text-xl', // Default size
  lg: 'text-2xl', // Larger contexts
};

export function Logo({ className = '', showText = true, size = 'md', href = '/' }: LogoProps) {
  return (
    <Link href={href} className={`flex items-center space-x-2 ${className}`}>
      <div className={`${sizeClasses[size]} relative flex-shrink-0`}>
        <Image
          src={LOGO_PATHS.mainTransparent}
          alt="Email Ferret Logo"
          width={500}
          height={500}
          className="w-full h-full object-contain"
          priority
        />
      </div>
      {showText && (
        <span className={`font-bold text-foreground ${textSizeClasses[size]}`}>Email Ferret</span>
      )}
    </Link>
  );
}
